const STORAGE_KEY = "bb_active_match";
const SNAPSHOT_KEY = "bb_match_snapshot";
const TTL_MS = 10 * 60 * 1000; // 10 minutes

export interface ActiveMatchSession {
  matchId: string;
  lobbyId: string;
  seed: number;
  localPlayerId: string;
  remotePlayerId: string;
  localSkinId: string;
  remoteSkinId: string;
  timestamp: number;
}

export interface MatchRunSnapshot {
  localRun: unknown;
  mirrorRun: unknown;
  savedAt: number;
}

export function saveActiveMatch(data: Omit<ActiveMatchSession, "timestamp">): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...data, timestamp: Date.now() }));
  } catch { /* localStorage full or unavailable */ }
}

export function loadActiveMatch(): ActiveMatchSession | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw == null) return null;
    const parsed = JSON.parse(raw) as ActiveMatchSession;
    if (Date.now() - parsed.timestamp > TTL_MS) {
      clearActiveMatch();
      return null;
    }
    return parsed;
  } catch {
    clearActiveMatch();
    return null;
  }
}

export function clearActiveMatch(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(SNAPSHOT_KEY);
  } catch { /* no-op */ }
}

export function saveMatchSnapshot(localRun: unknown, mirrorRun: unknown): void {
  try {
    localStorage.setItem(SNAPSHOT_KEY, JSON.stringify({
      localRun,
      mirrorRun,
      savedAt: Date.now(),
    }));
  } catch { /* localStorage full or unavailable */ }
}

export function loadMatchSnapshot(): MatchRunSnapshot | null {
  try {
    const raw = localStorage.getItem(SNAPSHOT_KEY);
    if (raw == null) return null;
    return JSON.parse(raw) as MatchRunSnapshot;
  } catch {
    return null;
  }
}
